module.exports = __webpack_public_path__ + "img/428-5058ef.png";